import React from "react";
import {isFunction} from "lodash";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import {
    ALTERNATE_SEND_BEFORE_SIGNUP_MESSAGE,
    QUESTION_PROMPTS_ENABLED,
    SEND_BEFORE_SIGNUP_ENABLED,
} from "shared/constants";
import {Heading, Text, View} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {useLocation} from "react-router-dom";

import {
    INTL_REPLY_NOTIFICATION_PROMPT,
    INTL_SIGN_UP_TO_CHAT,
    INTL_SIGN_UP_TO_GET_REPLY,
    INTL_SIGN_UP_TO_GET_REPLY_PROMPT,
} from "../../../../../translations/chat";
import {INTL_SIGN_UP_TO_DELIVER_MESSAGE} from "../../../../../translations/signup";
import {IntlNamespaces} from "../../../../../translations/types";
import {useIsScreenSizeLargerThan} from "../../../../../hooks/useIsScreenSizeLargerThan";

interface CreateAccountPopupHeadingProps {
    ambassadorFirstName: string;
}

export const CreateAccountPopupHeading: React.FC<CreateAccountPopupHeadingProps> = ({
    ambassadorFirstName,
}) => {
    const isSBSEnabled = useBooleanFeatureFlag(
        SEND_BEFORE_SIGNUP_ENABLED.key,
        SEND_BEFORE_SIGNUP_ENABLED.value,
    );
    const isQuestionPromptEnabled = useBooleanFeatureFlag(
        QUESTION_PROMPTS_ENABLED.key,
        QUESTION_PROMPTS_ENABLED.value,
    );
    const {pathname} = useLocation();
    const {t} = useTranslation([IntlNamespaces.CHAT, IntlNamespaces.SIGNUP]);
    const popupScreenSize = useIsScreenSizeLargerThan(632);
    const ALTERNATE_SIGN_UP_MESSAGE = useBooleanFeatureFlag(
        ALTERNATE_SEND_BEFORE_SIGNUP_MESSAGE.key,
        ALTERNATE_SEND_BEFORE_SIGNUP_MESSAGE.value,
    );
    const SIGN_UP_HEADER = ALTERNATE_SIGN_UP_MESSAGE
        ? INTL_SIGN_UP_TO_DELIVER_MESSAGE
        : INTL_SIGN_UP_TO_GET_REPLY;

    return (
        <>
            {(isQuestionPromptEnabled &&
                isSBSEnabled &&
                !pathname.includes("external") &&
                popupScreenSize) ||
            (isSBSEnabled && !pathname.includes("external")) ? (
                <View gap="small-medium">
                    <Heading level="2" size="small" align="center">
                        {t(
                            SIGN_UP_HEADER.key,
                            isFunction(SIGN_UP_HEADER.defaultValue)
                                ? SIGN_UP_HEADER.defaultValue(ambassadorFirstName)
                                : SIGN_UP_HEADER.defaultValue,
                        )}
                    </Heading>
                    <Text size="medium" align="center">
                        {t(
                            INTL_SIGN_UP_TO_GET_REPLY_PROMPT.key,
                            isFunction(INTL_SIGN_UP_TO_GET_REPLY_PROMPT.defaultValue)
                                ? INTL_SIGN_UP_TO_GET_REPLY_PROMPT.defaultValue(ambassadorFirstName)
                                : INTL_SIGN_UP_TO_GET_REPLY_PROMPT.defaultValue,
                            {
                                name: ambassadorFirstName,
                            },
                        )}
                    </Text>
                </View>
            ) : (
                <View gap="small-medium">
                    <Heading level="2" size="small" align="center">
                        {t(INTL_SIGN_UP_TO_CHAT.key, INTL_SIGN_UP_TO_CHAT.defaultValue)}
                    </Heading>
                    <Text size="medium" align="center">
                        {t(
                            INTL_REPLY_NOTIFICATION_PROMPT.key,
                            isFunction(INTL_REPLY_NOTIFICATION_PROMPT.defaultValue)
                                ? INTL_REPLY_NOTIFICATION_PROMPT.defaultValue(ambassadorFirstName)
                                : INTL_REPLY_NOTIFICATION_PROMPT.defaultValue,
                            {
                                name: ambassadorFirstName,
                            },
                        )}
                    </Text>
                </View>
            )}
        </>
    );
};
